import areEqual from "fbjs/lib/areEqual";
import { connect } from "react-redux";

import { iterateEntries } from "../../../../../Common/IterableUtils";
import { isNotNullOrUndefined } from "../../../../../Common/TypingUtils";
import { removeUnitTableWidth, setUnitTableWidth } from "../../../Engine/ActionCreators/UnitTableActionCreators";
import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import {
    getColumnGroupingGroupStates,
    getHiddenColgroupingGroupStates,
    getIsLoading,
} from "../../../Helpers/StateAccessors/ColgroupHelpers";
import { AbsoluteModelPath } from "../../../../../Common/ModelPath/ModelPath";

import { CrossfitTable } from "./CrossfitTable";

interface CrossfitTableContainerProps {
    bindingPath: AbsoluteModelPath;
    columnGrouping?: { [key: string]: [number, number] };
    hiddenGroups?: { [key: string]: number[] };
    isSticky?: boolean;
    "data-tid"?: string;
}

const FooterHeight = 80;
const NDFLFooterHeight = 120;

const mapStateToProps = (state: FullFormState, ownProps: CrossfitTableContainerProps) => {
    const { bindingPath, columnGrouping = {}, hiddenGroups = {} } = ownProps;

    const loading = getIsLoading(state, bindingPath.toLegacyPath());

    const groupedColumns = Object.keys(columnGrouping)
        .map(col => {
            if (!getColumnGroupingGroupStates(state, bindingPath.toLegacyPath(), col)) {
                return columnGrouping[col];
            }

            return undefined;
        })
        .filter(isNotNullOrUndefined)
        .filter(val => val);

    const hiddenColgroup: number[] = [];

    for (const [key, hiddenGroup] of iterateEntries(hiddenGroups)) {
        const hiddenColgroupState =
            getHiddenColgroupingGroupStates(state, bindingPath.toLegacyPath(), key).state || "auto";
        const hiddenColgroupFilledCount =
            getHiddenColgroupingGroupStates(state, bindingPath.toLegacyPath(), key).filledCount || 0;

        if (hiddenColgroupState === "hide" || (hiddenColgroupState === "auto" && !hiddenColgroupFilledCount)) {
            hiddenColgroup.push(...hiddenGroup);
        }
    }

    return {
        footerHeight: state.settings.gfv.startsWith("1131") ? NDFLFooterHeight : FooterHeight,
        groupedColumns: groupedColumns,
        isReadOnly: state.settings.isReadOnly,
        panelState: state.formVisualState.panelState,
        hiddenColgroup: hiddenColgroup,
        loading: loading,
        isWidePanel: state.formVisualState.isWidePanel,
        unitsWidth: state.units || {},
    };
};

const mapDispatchToProps = {
    setUnitTableWidth: setUnitTableWidth,
    removeUnitTableWidth: removeUnitTableWidth,
};

const connectOptions = { areStatePropsEqual: areEqual };

export const CrossfitTableContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
    undefined,
    connectOptions
)(CrossfitTable);
